export enum Roles {
  // Administrators = 1,
  // ForumModerators = 2,
  Registered = 'Registered',
  Guest = 'Guest',
  // Agents = 5,
  // CRM = 6,
  // StoreFullAdmin = 7,
  // StoreAdmin = 8,
}

export enum UserRoles {
  Administrators = 1,
  ForumModerators = 2,
  Registered = 3,
  Guests = 4,
  Agents = 5,
  CRM = 6,
  StoreFullAdmin = 7,
  StoreAdmin = 8,
  Products = 9,
  DocumentAdmin = 10,
  DocumentUser = 11,
  CollaboratingAgent = 15,
}

export const AllRoles = Object.values(Roles);

// const AllUsers = [
//   Roles.Administrators,
//   Roles.ForumModerators,
//   Roles.Registered,
//   Roles.Guest,
//   Roles.Agents,
//   Roles.CRM,
//   Roles.CRM,
//   Roles.StoreFullAdmin,
//   Roles.StoreAdmin,
// ];
// // .map((key: any) =>
// //   Number.parseInt(Roles[key])
// // );
// const RegisteredUsers = [Roles.Administrators, Roles.Agents, Roles.Registered];

// export default {
//   ...Roles,
//   All: AllUsers,
//   Registered: RegisteredUsers,
// };

export enum RoleName {
  Administrators = 1,
  ForumModerators = 2,
  Registered = 3,
  Guest = 4,
  Agents = 5,
  CRM = 6,
  StoreFullAdmin = 7,
  StoreAdmin = 8,
}
